import React, { useState, useContext, useEffect } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import firebase from "gatsby-plugin-firebase"
import { AuthContext } from "../context/auth"
import publicIp from "public-ip"
import { injectIntl, Link, navigate } from "gatsby-plugin-intl"
import Resizer from "react-image-file-resizer"
import axios from "axios"
import "firebase/firestore"
import GPS from "../components/apis/GpsMatias"

// import ConvertirZonaHoraria from "../components/Utiles/ConvertirZonaHoraria"
import {
  Button,
  Select,
  InputLabel,
  MenuItem,
  CssBaseline,
  TextField,
  Grid,
  FormControlLabel,
  Checkbox,
  Avatar,
  Typography,
  makeStyles,
  Container,
} from "@material-ui/core"
import { graphql } from "gatsby"
import usePaises from "../hooks/usePaises"
import useProvincias from "../hooks/useProvincias"
import useLocalidades from "../hooks/useLocalidades"
import avatar from "../images/avatar_subir.png"

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  link: {
    textDecoration: "none",
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    padding: 8,
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    padding: 8,
  },
}))

const Registro = ({ intl, data }) => {
  const {
    nombre,
    registro_dinamico,
    bienvenida,
    link_planilla_registro,
    ingreso_habilitado,
    alert_ingreso_habilitado,
    boton_registrarme,
    boton_volver_login,
    alert_campos_obligatorios,
    alert_email_en_uso,
    alert_email_mal_escrito,
    alert_clave_cantidad_caracteres,
    comunique_error_al_proveedor,
  } = data.strapiRegistro

  const currentLocale = intl.locale
  const paises = usePaises()
  const provincias = useProvincias()
  const localidades = useLocalidades()
  paises.sort(function (a, b) {
    let left = a.nombre_pais
    let right = b.nombre_pais
    return left === right ? 0 : left > right ? 1 : -1
  })
  const fileChangedHandler = event => {
    // console.log("event", event.target.name)

    var fileInput = false
    if (event.target.files[0]) {
      fileInput = true
    }
    if (fileInput) {
      try {
        Resizer.imageFileResizer(
          event.target.files[0], //file
          200, //maxWidth
          200, //maxHeight
          "PNG", // compressFormat Can be either JPEG, PNG or WEBP.
          80, // quality
          0, //rotation
          uri => {
            //responseUriFunc Callback function of URI. Returns URI of resized image's base64 format. ex: uri => {console.log(uri)});
            // setImagenElegida(uri) // ACA que hacer CON LA IMAGEN setDataRegistro({ ...dataRegistro, })
            // COMO LE METO LA VARIABLE ACA NO SE TODAVIA event, variable?
            setDataRegistro({ ...dataRegistro, [event.target.name]: uri })
          },
          "base64", //outputType Can be either base64, blob or file.(Default type is base64)
          100, //minWidth
          100 //minHeight
        )
      } catch (err) {
        console.log(err)
      }
    }
  }

  const [dataRegistro, setDataRegistro] = useState({
    // email: "",
    // password: "",
    // error: null,
    // front: true,
  })
  const [ip, setIp] = useState("")
  useEffect(() => {
  //   let datita = { email: "", password: "", error: null, front: true, ip: result }
  //   // if (ip !== "") {
  //     registro_dinamico.map(items => {
  //       if (items.strapi_component === "registro.campo-checkbox") {
  //         // setDataRegistro({...dataRegistro, [items.variable]: items.marcado })
  //         datita[items.variable] = items.marcado
  //       }
  //     })
  //     setDataRegistro(datita)
    // }
  }, [])
  // para que no hagan log de 2 ip diferentes
  const getClientIp = async () =>
    await publicIp.v4({
      fallbackUrls: ["https://ifconfig.co/ip"],
    })

  useEffect(() => {
    getClientIp().then(result => {
      // setDataRegistro({ ...dataRegistro, ip: result })

      let datita = { email: "", password: "", front: true, ip: result }
      // if (ip !== "") {
        registro_dinamico.map(items => {
          if (items.strapi_component === "registro.campo-checkbox") {
            // setDataRegistro({...dataRegistro, [items.variable]: items.marcado })
            datita[items.variable] = items.marcado
          }
        })
        setDataRegistro(datita)
    })
  }, [])
  const { user, setUser } = useContext(AuthContext)
  const [btnDisabled, setBtnDisabled] = useState(false)

  const handleChange = e => {
    setDataRegistro({ ...dataRegistro, [e.target.name]: e.target.value }) //agregue .trim() revisar si andan bien todos los campos
  }
  const CodigoPais = pais => {
    let alfa2
    paises.filter(function (paisFiltrado) {
      if (
        paisFiltrado.nombre.es.toLowerCase().includes(pais.toLowerCase()) ||
        paisFiltrado.nombre.en.toLowerCase().includes(pais.toLowerCase()) ||
        paisFiltrado.nombre.pt.toLowerCase().includes(pais.toLowerCase())
      ) {
        if (
          paisFiltrado.nombre.es.toLowerCase() === pais.toLowerCase() ||
          paisFiltrado.nombre.en.toLowerCase() === pais.toLowerCase() ||
          paisFiltrado.nombre.pt.toLowerCase() === pais.toLowerCase()
        ) {
          alfa2 = paisFiltrado.alfa2
        }
      }
    })
    return alfa2
  }
  /****************
   * codigo pais fin
   */
  const camposObligatorios = () => {
    //TODO probar funcionamiento
    let habilitado = true
    registro_dinamico.forEach(function (items) {
      if (
        items.obligatorio === true &&
        (!dataRegistro[items.variable] ||
          dataRegistro[items.variable].trim() === "")
      ) {
        habilitado = false
      }
    })
    return habilitado
  }

  const ConvertirZonaHoraria = () => {
    let date = new Date()
    function convertTZ(date, tzString) {
      return new Date(
        (typeof date === "string" ? new Date(date) : date).toLocaleString(
          "en-US", // TODO ver si esto tambien viene del strapi
          { timeZone: tzString }
        )
      )
    }
    let convertida = convertTZ(date, data.strapiConfiguracion.zona_horaria)
    // let convertida = convertTZ(new Date(), configuracion.zona_horaria)
    let dateConvertida =
      // convertida.getDate() +
      ("0" + convertida.getDate()).slice(-2) +
      "/" +
      ("0" + (convertida.getMonth() + 1)).slice(-2) +
      // (convertida.getMonth() + 1) +
      "/" +
      convertida.getFullYear()

    let timeConvertida =
      ("0" + convertida.getHours()).slice(-2) +
      // convertida.getHours() +
      ":" +
      ("0" + convertida.getMinutes()).slice(-2) +
      // convertida.getMinutes() +
      ":" +
      // convertida.getSeconds()
      ("0" + convertida.getSeconds()).slice(-2)

    return dateConvertida + " " + timeConvertida
  }

  const handleSubmit = async e => {
    e.preventDefault()
    // setDataRegistro({ ...dataRegistro, error: null })
    matiProcesado()

    if (camposObligatorios()) {
      // setDataRegistro({
      //   ...dataRegistro,
      //   fecha: Date.now().toString(),
      //   codpais: CodigoPais(dataRegistro.pais),
      //   zona_horaria_cliente: ConvertirZonaHoraria(),
      //   // zona_horaria_cliente: horaConv,
      // })

      firebase
        .auth()
        .createUserWithEmailAndPassword(
          dataRegistro.email.trim(),
          dataRegistro.password
        )
        .then(result2 => {
          setUser(result2.user)
          setBtnDisabled(true)
          //agregar uid fecha y demas a dataRegistro antes de que siga
          grabarPlanilla()

          // result2.user
          //   .sendEmailVerification()
          //   .then(function () {
          //     // Email sent.
          //     alert(
          //       "Por favor verifique su email y haga click en el vinculo para poder ingresar"
          //     )
          //   })
          //   .catch(function (error) {
          //     // An error happened.
          //   })
        })
        .catch(function (error) {
          error.message ===
          "The email address is already in use by another account."
            ? alert(
                currentLocale === "en"
                  ? alert_email_en_uso.en
                  : currentLocale === "pt"
                  ? alert_email_en_uso.pt
                  : alert_email_en_uso.es
              )
            : error.message === "The email address is badly formatted."
            ? alert(
                currentLocale === "en"
                  ? alert_email_mal_escrito.en
                  : currentLocale === "pt"
                  ? alert_email_mal_escrito.pt
                  : alert_email_mal_escrito.es
              )
            : error.message === "Password should be at least 6 characters"
            ? alert(
                currentLocale === "en"
                  ? alert_clave_cantidad_caracteres.en
                  : currentLocale === "pt"
                  ? alert_clave_cantidad_caracteres.pt
                  : alert_clave_cantidad_caracteres.es
              )
            : alert(
                currentLocale === "en"
                  ? comunique_error_al_proveedor.en
                  : currentLocale === "pt"
                  ? comunique_error_al_proveedor.pt
                  : comunique_error_al_proveedor.es,
                error.message
              ) //TODO revisar si se ve el mensaje de error
        })
    } else {
      alert(
        currentLocale === "en"
          ? alert_campos_obligatorios.en
          : currentLocale === "pt"
          ? alert_campos_obligatorios.pt
          : alert_campos_obligatorios.es
      )
    }
  }

  const handleChangeTel = e => {
    const value = e.target.value.replace(/\D/g, "")
    setDataRegistro({ ...dataRegistro, [e.target.name]: value })
  }
  const docRef = firebase.firestore().collection("usuarios")

  useEffect(() => {
    if (user != null) {
     
      let subirDatos = dataRegistro
      Object.assign(subirDatos, {
        codpais: dataRegistro.pais ? CodigoPais(dataRegistro.pais) : "",
        front: true,
        uid: user.uid,
        zona_horaria_cliente: ConvertirZonaHoraria(),
      })
      delete subirDatos.password
      // console.log("subirdatos", subirDatos)


      docRef
        .doc(user.uid)
        .get()
        .then(value => {
          // if (false) {
          if (value.exists) {
            navigate("/inicio")
          } else {
            docRef
              .doc(user.uid)
              .set(subirDatos)
              .then(res => {
                user
                  .updateProfile({
                    displayName: `${dataRegistro.nombre.trim()} ${dataRegistro.apellido.trim()}`,
                  })
                  .then(function () {
                    if (ingreso_habilitado) {
                      navigate("/inicio")
                    } else {
                      alert(
                        currentLocale === "en"
                          ? alert_ingreso_habilitado.en
                          : currentLocale === "pt"
                          ? alert_ingreso_habilitado.pt
                          : alert_ingreso_habilitado.es
                      )
                      firebase.auth().signOut()
                      navigate("/")
                    }
                  })
                  .catch(function (error) {})
              })
          }
        })
    }
  }, [user])

  const grabarPlanilla = () => {
    axios.post(link_planilla_registro, dataRegistro)
  }
  const handleChangeCheckbox = event => {
    setDataRegistro({
      ...dataRegistro,
      [event.target.name]: event.target.checked,
    })
  }

  const classes = useStyles()

  // GPS a mati
  const [subidaMatias, setSubidaMatias] = useState({})
  const matiProcesado = () => {
    let pushMatias = []
    for (let key in dataRegistro) {
      let nuevo = {
        variable: "",
        valor: [],
        tipoVariable: "string",
      }
      nuevo.variable = key
      nuevo.valor[0] = dataRegistro[key]

      if (
        (nuevo.valor[0] !== null || nuevo.valor[0] !== undefined) &&
        key !== "password" &&
        key !== "zona_horaria_cliente" &&
        key !== "nombre" &&
        key !== "apellido" &&
        key !== "email" &&
        key !== "front" &&
        key !== "avatar" &&
        key !== "rubro"
        // me parece que los booleans no estan pasando se pintan pero no se graban en objeto revisar
        //cuando hacer
      ) {
        pushMatias.push(nuevo)
      }

      // pushMatias.push(nuevo)
    }
    setSubidaMatias(pushMatias)
  }

  useEffect(() => {
    if (user != null) {
      // matiProcesado()
      let gpsTestRegistroSubir = {
        nombre: dataRegistro.nombre,
        apellido: dataRegistro.apellido,
        uid: user.uid,
        email: dataRegistro.email,
        datos: subidaMatias,
        gmtEntrada: Date.now().toString(),
        avatar: dataRegistro.avatar ? dataRegistro.avatar : null,
        rubro: dataRegistro.rubro ? [dataRegistro.rubro] : null,
      }

      // console.log("registo SUBIR ", gpsTestRegistroSubir)
      GPS.post(`planillas/registro`, gpsTestRegistroSubir)
        .then(res => {})
        // .catch(error => alert(`error en POST: ${error}`))
        .catch(error => console.log("error en POST ", error))
    }
  }, [user])

  // console.log("dataRegistro", dataRegistro)
  // registro_dinamico.map(items =>
  //   console.log("items.strapi_component", items.strapi_component)
  // )
  return (
    <Layout>
      <SEO
        title={
          currentLocale === "en"
            ? nombre.en
            : currentLocale === "pt"
            ? nombre.pt
            : nombre.es
        }
      />
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          {/* TODO le falta el tamaño y coloor de letras
        mejor usar el hidden y se use tamaño de letra en grande y celular no se pase valor envolviendo el typography 
        ESTO PARA LA VERSION 3 un componente texto con tamaño color fuente peso*/}
          <Typography component="h1" variant="h5">
            {currentLocale === "en"
              ? bienvenida.en
              : currentLocale === "pt"
              ? bienvenida.pt
              : bienvenida.es}
          </Typography>
          {/* <button onClick={matiProcesado}>Procesar matias</button> */}
          <form className={classes.form} noValidate onSubmit={handleSubmit}>
            {registro_dinamico.map(items =>
            //console.log("items.strapi_component", items.strapi_component)
              items.mostrar ? (
                <div key={items.variable}>
                  {items.strapi_component === "registro.campo-texto" ? (
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required={items.obligatorio}
                      fullWidth
                      name={items.variable}
                      label={
                        currentLocale === "en"
                          ? items.label.en
                          : currentLocale === "pt"
                          ? items.label.pt
                          : items.label.es
                      }
                      type="text"
                      id={items.variable}
                      value={
                        dataRegistro[items.variable]
                          ? dataRegistro[items.variable]
                          : ""
                      }
                      onChange={handleChange}
                    />
                  ) : items.strapi_component === "registro.campo-email" ? (
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required={items.obligatorio}
                      fullWidth
                      id={items.variable}
                      label={
                        currentLocale === "en"
                          ? items.label.en
                          : currentLocale === "pt"
                          ? items.label.pt
                          : items.label.es
                      }
                      name={items.variable}
                      autoComplete="email"
                      value={
                        dataRegistro[items.variable]
                          ? dataRegistro[items.variable]
                          : ""
                      }
                      onChange={handleChange}
                    />
                  ) :
                  
                  items.strapi_component === "registro.campo-tos" ? (
                   
                    <TextField
                      variant="outlined"
                      margin="normal"
                      multiline
                      rows={4}
                      fullWidth
                      key="tos"
                      // id={items.variable}
                      label={
                        currentLocale === "en"
                        ? items.label.en
                        : currentLocale === "pt"
                        ? items.label.pt
                        : items.label.es
                      }
                      name="tos"
                      value={
                        currentLocale === "en"
                        ? items.texto_tos.en
                        : currentLocale === "pt"
                        ? items.texto_tos.pt
                        : items.texto_tos.es
                        
                      }
                    />
                
                  ) :
                  
                  items.strapi_component === "registro.campo-password" ? (
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required={items.obligatorio}
                      fullWidth
                      name={items.variable}
                      label={
                        currentLocale === "en"
                          ? items.label.en
                          : currentLocale === "pt"
                          ? items.label.pt
                          : items.label.es
                      }
                      type="password"
                      id={items.variable}
                      autoComplete="current-password"
                      value={
                        dataRegistro[items.variable]
                          ? dataRegistro[items.variable]
                          : ""
                      }
                      onChange={handleChange}
                    />
                  ) : items.strapi_component === "registro.campo-checkbox" ? (
                    <FormControlLabel
                      checked={
                        dataRegistro[items.variable] === undefined
                          ? items.marcado
                          : dataRegistro[items.variable]
                      }
                      style={{ padding: 15 }}
                      name={items.variable}
                      onChange={handleChangeCheckbox}
                      control={
                        <Checkbox
                          value={dataRegistro[items.variable]}
                          color="primary"
                        />
                      }
                      label={
                        currentLocale === "en"
                          ? items.label.en
                          : currentLocale === "pt"
                          ? items.label.pt
                          : items.label.es
                      }
                    />
                  ) : items.strapi_component === "registro.campo-titulo" ? (
                    <Typography
                      component="h5"
                      variant="h5"
                      style={{ color: items.color_letra }}
                    >
                      {currentLocale === "en"
                        ? items.texto.en
                        : currentLocale === "pt"
                        ? items.texto.pt
                        : items.texto.es}
                    </Typography>
                  ) : items.strapi_component === "registro.campo-avatar" ? (
                    <>
                      {dataRegistro[items.variable] === null ||
                      dataRegistro[items.variable] === undefined ||
                      dataRegistro[items.variable] === "" ? (
                        <Button component="label" fullWidth>
                          <Avatar
                            alt="avatar"
                            src={avatar}
                            style={{ width: 100, height: 100 }}
                          />
                          <input
                            type="file"
                            hidden
                            name={items.variable}
                            onChange={fileChangedHandler}
                          />
                        </Button>
                      ) : (
                        <Button component="label" fullWidth>
                          <Avatar
                            alt="avatar"
                            src={dataRegistro[items.variable]}
                            style={{ width: 100, height: 100 }}
                          />
                          <input
                            type="file"
                            hidden
                            name={items.variable}
                            onChange={fileChangedHandler}
                          />
                        </Button>
                      )}
                    </>
                  ) : items.strapi_component === "registro.campo-telefono" ? (
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required={items.obligatorio}
                      fullWidth
                      name={items.variable}
                      label={
                        currentLocale === "en"
                          ? items.label.en
                          : currentLocale === "pt"
                          ? items.label.pt
                          : items.label.es
                      }
                      type="tel"
                      id={items.variable}
                      value={dataRegistro[items.variable]}
                      onChange={handleChangeTel}
                    />
                  ) : items.strapi_component === "registro.campo-pais" ? (
                    <>
                      <InputLabel id="paisLabel" style={{ padding: 15 }}>
                        {currentLocale === "en"
                          ? items.label.en
                          : currentLocale === "pt"
                          ? items.label.pt
                          : items.label.es}
                      </InputLabel>
                      <Select
                        style={{ width: "100%", padding: 10 }}
                        id={items.variable}
                        name={items.variable}
                        value={
                          dataRegistro[items.variable]
                            ? dataRegistro[items.variable]
                            : ""
                        }
                        onChange={handleChange}
                      >
                        {paises.map(pais =>
                          pais.mostrar ? (
                            <MenuItem
                              value={pais.nombre.es}
                              key={pais.nombre.es}
                            >
                              {currentLocale === "en"
                                ? pais.nombre.en
                                : currentLocale === "pt"
                                ? pais.nombre.pt
                                : pais.nombre.es}
                            </MenuItem>
                          ) : (
                            ""
                          )
                        )}
                      </Select>
                    </>
                  ) : items.strapi_component === "registro.campo-provincia" ? (
                    dataRegistro.pais === "Argentina" ? (
                      <>
                        <InputLabel id="provinciaLabel" style={{ padding: 15 }}>
                          {currentLocale === "en"
                            ? items.label.en
                            : currentLocale === "pt"
                            ? items.label.pt
                            : items.label.es}
                        </InputLabel>
                        <Select
                          style={{ width: "100%", padding: 10 }}
                          id={items.variable}
                          value={
                            dataRegistro[items.variable]
                              ? dataRegistro[items.variable]
                              : ""
                          }
                          onChange={handleChange}
                          name={items.variable}
                        >
                          {provincias.map(provincia =>
                            provincia.mostrar &&
                            provincia.pais === dataRegistro.pais ? (
                              <MenuItem
                                value={provincia.nombre}
                                key={provincia.nombre}
                              >
                                <>
                                  {currentLocale === "en"
                                    ? provincia.nombre
                                    : currentLocale === "pt"
                                    ? provincia.nombre
                                    : provincia.nombre}
                                </>
                              </MenuItem>
                            ) : (
                              ""
                            )
                          )}
                        </Select>
                      </>
                    ) : dataRegistro.pais !== "" &&
                      dataRegistro.pais !== undefined ? (
                      <TextField
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        name={items.variable}
                        label={
                          currentLocale === "en"
                            ? items.label.en
                            : currentLocale === "pt"
                            ? items.label.pt
                            : items.label.es
                        }
                        type="text"
                        id={items.variable}
                        value={
                          dataRegistro[items.variable]
                            ? dataRegistro[items.variable]
                            : ""
                        }
                        onChange={handleChange}
                      />
                    ) : (
                      ""
                    )
                  ) : items.strapi_component === "registro.campo-localidad" ? (
                    dataRegistro.pais === "Argentina" &&
                    dataRegistro.provincia !== "" &&
                    dataRegistro.provincia !== undefined ? (
                      <>
                        <InputLabel id="localidadLabel" style={{ padding: 15 }}>
                          {currentLocale === "en"
                            ? items.label.en
                            : currentLocale === "pt"
                            ? items.label.pt
                            : items.label.es}
                        </InputLabel>
                        <Select
                          style={{ width: "100%", padding: 10 }}
                          id={items.variable}
                          value={
                            dataRegistro[items.variable]
                              ? dataRegistro[items.variable]
                              : ""
                          }
                          name={items.variable}
                          onChange={handleChange}
                        >
                          {localidades.map(localidad =>
                            localidad.mostrar &&
                            localidad.provincia === dataRegistro.provincia ? (
                              <MenuItem
                                value={localidad.nombre}
                                key={localidad.nombre}
                              >
                                <>
                                  {currentLocale === "en"
                                    ? localidad.nombre
                                    : currentLocale === "pt"
                                    ? localidad.nombre
                                    : localidad.nombre}
                                </>
                              </MenuItem>
                            ) : (
                              ""
                            )
                          )}
                        </Select>
                      </>
                    ) : dataRegistro.pais !== "" &&
                      dataRegistro.provincia !== "" &&
                      dataRegistro.provincia !== undefined ? (
                      <TextField
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        name={items.variable}
                        label={
                          currentLocale === "en"
                            ? items.label.en
                            : currentLocale === "pt"
                            ? items.label.pt
                            : items.label.es
                        }
                        type="text"
                        id={items.variable}
                        value={
                          dataRegistro[items.variable]
                            ? dataRegistro[items.variable]
                            : ""
                        }
                        onChange={handleChange}
                      />
                    ) : (
                      ""
                    )
                  ) : items.strapi_component ===
                    "registro.campo-desplegable" ? (
                    <>
                      <InputLabel style={{ padding: 15 }}>
                        {currentLocale === "en"
                          ? items.label.en
                          : currentLocale === "pt"
                          ? items.label.pt
                          : items.label.es}
                      </InputLabel>
                      <Select
                        style={{ width: "100%", padding: 10 }}
                        id={items.variable}
                        value={
                          dataRegistro[items.variable]
                            ? dataRegistro[items.variable]
                            : ""
                        }
                        name={items.variable}
                        onChange={handleChange}
                      >
                        {items.items.map(item => (
                          <MenuItem value={item.es} key={item.es}>
                            {currentLocale === "en"
                              ? item.en
                              : currentLocale === "pt"
                              ? item.pt
                              : item.es}
                          </MenuItem>
                        ))}
                      </Select>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              // color="primary"
              disabled={btnDisabled}
              className={classes.submit}
              style={{
                background: `${boton_registrarme.color_fondo}`,
                color: `${boton_registrarme.color_letra}`,
              }}
            >
              {currentLocale === "en"
                ? boton_registrarme.en
                : currentLocale === "pt"
                ? boton_registrarme.pt
                : boton_registrarme.es}
            </Button>
            <Grid container>
              <Grid item xs>
                <Link to={"/"} className={classes.link}>
                  <Button
                    fullWidth
                    variant="contained"
                    //color="primary"
                    className={classes.submit}
                    disabled={btnDisabled}
                    style={{
                      background: `${boton_volver_login.color_fondo}`,
                      color: `${boton_volver_login.color_letra}`,
                    }}
                  >
                    {currentLocale === "en"
                      ? boton_volver_login.en
                      : currentLocale === "pt"
                      ? boton_volver_login.pt
                      : boton_volver_login.es}
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </Layout>
  )
}

export default injectIntl(Registro)

export const query = graphql`
  query {
    strapiConfiguracion {
      zona_horaria
    }
    strapiRegistro {
      registro_dinamico
      alert_email_en_uso {
        es
        en
        pt
      }
      alert_email_mal_escrito {
        es
        en
        pt
      }
      alert_clave_cantidad_caracteres {
        es
        en
        pt
      }
      comunique_error_al_proveedor {
        es
        en
        pt
      }
      alert_campos_obligatorios {
        es
        en
        pt
      }
      nombre {
        es
        en
        pt
      }
      boton_volver_login {
        es
        en
        pt
        color_fondo
        color_letra
      }
      boton_registrarme {
        es
        en
        pt
        color_fondo
        color_letra
      }
      ingreso_habilitado
      alert_ingreso_habilitado {
        es
        en
        pt
      }
      link_planilla_registro
      bienvenida {
        es
        en
        pt
      }
    }
  }
`
